<div class="d-flex container-fluid p-0 apiContainer" id="wrapper">
  <!-- Sidebar-->
  <div class="border-end bg-white" id="sidebar-wrapper">
    <span onclick="openNav()" class="openbtnIAG"><i class="fa fa-bars fa-lg"></i></span>
    <div class="list-group list-group-flush">
      <div id="mySidenav" class="sidenav scrollToContent">
        <div class="nav-header">
          <a href="javascript:void(0)" class="closebtnIAG" onclick="closeNav()">
            <i class="fa fa-bars fa-lg"></i>
          </a>
        </div>
        <div id="sideMenu-header" class="sideMenu-header">
          <a href="/home">
            <img class="sideMenu-logo logo5" [src]="configService.getLogo('BA_LOGO_MOBILE')" />
          </a>
        </div>
        <div class="sidebar-nav">
          <ul class="parent">
            <span class="notSubmenu">
              <a href="/" class="liclass">
                <span class="nav-text"> <i class="fa fa-home fa-smx"></i>NDC Hub</span>
              </a>
            </span>
            <li *ngFor="let category of categories; let i = index" class="parent-menu{{ i }}" [ngClass]="category?.subMenuIconClass ? 'submenu' : ''">
              <a class="liclass" attr.id="{{ i }}" (click)="setPageTitle(category.pageTitle || ''); closeNav()">
                <span class="nav-text"> {{ category.title }}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="apiContainerRight">
    <app-operational-assurances-ndc-health-check-dashboard-page *ngIf="pageTitle === 'NDC Health Check Dashboard'"></app-operational-assurances-ndc-health-check-dashboard-page>
    <app-operational-assurances-info-page *ngIf="pageTitle === 'Operational Assurances Info'"></app-operational-assurances-info-page>
    <app-operational-assurances-kpi-definitions-page *ngIf="pageTitle === 'KPI Definitions'"></app-operational-assurances-kpi-definitions-page>
  </div>
</div>
